import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class Ac2QueuesProvider extends HttpRequest {
  getAc2Queues (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/ac2/queues', query)
  }

  updateAc2QueueById (payload) {
    this.setHeader(getAuthToken())
    return this.patch(`/ac2/queues/${payload.id}`, payload)
  }

  forceRun (id) {
    this.setHeader(getAuthToken())
    return this.patch(`/ac2/queues/${id}/forcerun`)
  }
}
